/*
Just a wrapper for local storage with all the variables I want to store as a user pref 
*/

class USERPREFS
{
    date_range_entries={value:"custom", name:""};//name will be the var name as a string to store it

    user_selected={value:"1", name:""};//name will be the var name as a string to store it // NOTE:DEXIEJS defaults to 1 based index instead of 0...



    // user_prefs = ["date_range_entries"]
    constructor()
    {
        console.log("UserPref: constructor ran!");
        // this.SetPrefsNames();
        this.GetAllUserPrefs();
    }
    // SetPrefsNames()
    // {
    // }
    GetAllUserPrefs()
    {
        //WARNING - THIS STORES/ RETRIEVES EVERYTHING AS STRINGS - SO NEED TO CONVERT NUMBERS BACK TO NUMBERS!
        let vars = Object.keys(this)
        for (let i = 0; i < vars.length; i++) 
        {
            const pref = vars[i];

            //setting the pref to have the name being its var name, for saving/ indexing
            (this as any)[pref].name= pref;


            let new_val = localStorage.getItem(pref);
            if(new_val!==null)
            {
                //if the default value is a number, convert the loaded string back to a number, or errors when using it:
                if(Number.isInteger((this as any)[pref].value))
                //@ts-ignore
                    new_val = parseInt(new_val);
                (this as any)[pref].value = new_val;
            }

            console.log("UserPref: got item: ", pref, "value: ", (this as any)[pref]);            
        }
    }
    SavePref(pref_name:string, value:any)
    {
        console.log("UserPref: saving item and vlaue: ", pref_name, value); 
        (this as any)[pref_name].value = value;
        localStorage.setItem(pref_name, value);
    }
    /* SetDateRangeEntities(val:string)
    {
        localStorage.setItem("date_range_entries", val);
    } */
}

export const UserPrefs = new USERPREFS();